import React from 'react';

const MapPlaceHolder = ({ language }) => {
    const SOURCES = {
        da: 'OoBtlhMiLY3ljM9awBGW61VaRaq',
        fr: 'PFb5QsSlYWYGjzj_fnIcrcskix8',
        nb: 'OoBtlhMiLY3ljM9awBGW61VaRss',
        sv: 'OoBtlhMiLY3ljM9awBGW61VaRzz',
    };

    return <img className="map-placeholder" src={`//static.uniid.it/${SOURCES[language]}`} alt="Unisport Flagship Store" />
};

export default MapPlaceHolder;
